import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'
import router from '../router'
import { Message } from 'element-ui'

const apiHost = process.env.API_HOST
//
/* axios配置 */
axios.defaults.retry = 5 /* 重试请求次数 */
axios.defaults.retryDelay = 600 /* 请求延迟 */
axios.defaults.timeout = 30000 /* 响应超时时间 */
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'          /* 配置请求头 */
axios.defaults.baseURL = apiHost /* 配置接口地址 */

// let userInfo = sessionStorage.getItem('user')
// if (userInfo) {
// 	userInfo = JSON.parse(userInfo)
// }
/* POST传参序列化(添加请求拦截器) */
axios.interceptors.request.use(
    // new Vue().$Loading.start()
    /* 在发送请求之前做某件事 */
    //
    config => {
        let userInfo_token = localStorage.getItem('user')
        //let userInfo_token = sessionStorage.getItem('user')//登录时token存在了session里
        if (userInfo_token) {
            userInfo_token = JSON.parse(userInfo_token)
            config.headers.Authorization = userInfo_token
        }
        // let token = sessionStorage.getItem('token');
        // if(token) {
        //   config.headers.Authorization = token;
        // }
        // NProgress.start();
        return config;
    },
    (error) => {

        return Promise.reject(error)
    })

/* 返回状态判断(添加响应拦截器) */
axios.interceptors.response.use((res) => {
    // new Vue().$Loading.finish()
    /* 对响应数据做些事 */
    // if (!res.data.success) {
    // 	return Promise.reject(res)
    // }
    // if (sessionStorage.getItem('token')) {  /* 在header上添加token */
    // res.headers.Authorization = sessionStorage.getItem('token')
    // }
    //
    
    if(res.data.result =="90000002"){//账户在其他地方登录，重新登录
        Message.error('账户在其他地方登录，请重新登录')
        localStorage.clear()
        sessionStorage.clear();
        router.push('/login')
    }
    return res
}, (error) => {
    return Promise.reject(error)
})

/* 返回一个Promise(发送post请求 下载文档/表格) */
export function fetchPostBlob(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url,
            data: params,
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            },
            responseType: 'blob',
            transformRequest: [
                function() {
                    return JSON.stringify(params);
                }
            ],
        }).then(response => {
            resolve(response.data)
        }, err => {
            reject(err)
        }).catch((error) => {
            reject(error)
        })
    })
}

/* 返回一个Promise(发送post请求) */
export function fetchPost(url, params) {
    return new Promise((resolve, reject) => {
        axios({
                method: "post",
                url,
                data: params,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8"
                },
                transformRequest: [
                    function() {
                        return JSON.stringify(params);
                    }
                ],
            })
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {

                reject(error)
            })
    })
}

/* 返回一个Promise(发送get请求) */
export function fetchGet(url, params) {
    return new Promise((resolve, reject) => {
        axios({
                method: "get",
                url,
                params
            })
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


// WEBPACK FOOTER //
// ./src/api/index.js